import { render, staticRenderFns } from "./renewalRateBonus.vue?vue&type=template&id=644ea47f&scoped=true"
import script from "./renewalRateBonus.vue?vue&type=script&lang=js"
export * from "./renewalRateBonus.vue?vue&type=script&lang=js"
import style0 from "./renewalRateBonus.vue?vue&type=style&index=0&id=644ea47f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644ea47f",
  null
  
)

export default component.exports